// extracted by mini-css-extract-plugin
export default {"aboutNewsletterContainerBox":"styles_aboutNewsletterContainerBox__e-BZV"};